import script from "./buttonGroups.vue?vue&type=script&setup=true&name=ButtonGroups&lang=js"
export * from "./buttonGroups.vue?vue&type=script&setup=true&name=ButtonGroups&lang=js"

import "./buttonGroups.vue?vue&type=style&index=0&id=4f17ff7b&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f17ff7b"]])

export default __exports__